export default "__VITE_ASSET__f4c5da44__"